import { useTranslation } from 'react-i18next';
import { ApiError } from '../api/client.js';

/**
 * Render an API failure.
 *
 * The API returns a stable machine-readable CODE, never user-facing prose. The
 * message shown here comes from the i18n catalogue keyed by that code, which
 * is what keeps the API locale-independent and reusable by a future mobile
 * client. An unrecognised code falls back to a generic message rather than
 * showing the raw English the server happened to send. The request id is NOT
 * shown: it means nothing to the person reading the message, and the server
 * log already records it with the failure.
 */
export function ErrorNotice({ error }: { error: unknown }) {
  const { t } = useTranslation();

  if (!error) return null;

  const code = error instanceof ApiError ? error.code : 'unknown';
  const message = t(`errors.${code}`, { defaultValue: t('errors.unknown') });

  return (
    <div
      role="alert"
      className="rounded-medium border border-danger-200 bg-danger-50 px-4 py-3 text-sm text-danger-700"
    >
      <p>{message}</p>
    </div>
  );
}
